module.exports = __webpack_public_path__ + "img/close.05f7a53a.png";